import { cva } from 'class-variance-authority';

const stepperLineBaseStylesSAG = cva(
  ['flex', 'items-center', 'justify-center'],
  {
    variants: {
      orientation: {
        vertical: ['min-h-6', 'h-full', 'w-full'],
        horizontal: ['h-0.5', 'w-full'],
      },
    },
  },
);

const stepperLineBaseStylesSHS = cva(
  ['flex', 'items-center', 'justify-center'],
  {
    variants: {
      orientation: {
        vertical: ['min-h-6', 'h-full', 'w-full'],
        horizontal: ['h-0.5', 'w-full'],
      },
    },
  },
);

export { stepperLineBaseStylesSAG, stepperLineBaseStylesSHS };
